import { render, staticRenderFns } from "./pacakage-card-order-detail.vue?vue&type=template&id=02188537&scoped=true&"
import script from "./pacakage-card-order-detail.vue?vue&type=script&lang=js&"
export * from "./pacakage-card-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02188537",
  null
  
)

export default component.exports